import React from "react";

// Owner-supplied master brand files — used byte-for-byte, never recolored or redrawn.
const WORDMARK = "/brand/bibleplaza-wordmark.png";          // flared-leg figures, transparent (canonical)
const LOCKUP_MASTER = "/brand/bibleplaza-lockup-master.webp";  // app icon + wordmark on navy
const APP_ICON_MASTER = "/brand/bibleplaza-app-icon-master.jpg"; // coral app icon (flared-leg figures)
const NAVY = "#1D1F2F"; // matches the master files' background

export function BpAppIcon({ size = 34, radius = 9, className = "" }) {
  return (
    <img src={APP_ICON_MASTER} alt="BiblePlaza"
      className={className}
      style={{ width: size, height: size, borderRadius: radius, display: "block" }} />
  );
}

// Back-compat: the figure-i mark now comes from the app icon master.
export function BpMark({ size = 26, className = "", ...rest }) {
  return <BpAppIcon size={size} radius={size * 0.26} className={className} {...rest} />;
}

/**
 * Primary BiblePlaza logo (owner master, wordmark on navy). Shown inside a
 * rounded chip whose background matches the file so edges read as a clean badge
 * on any page background. The image itself is never altered.
 */
export function BpLogo({ size = 24, className = "", ...rest }) {
  return (
    <span
      className={`inline-flex items-center rounded-xl ${className}`}
      style={{ background: NAVY, paddingTop: size * 0.34, paddingBottom: size * 0.34, paddingLeft: size * 0.5, paddingRight: size * 0.5 }}
      data-testid="bp-logo"
      {...rest}
    >
      <img src={WORDMARK} alt="BiblePlaza" style={{ height: size, width: "auto", display: "block" }} />
    </span>
  );
}

export { WORDMARK, LOCKUP_MASTER, APP_ICON_MASTER };

export function BadgePill({ children, tone = "muted", className = "", ...rest }) {
  const tones = {
    muted: "bg-[#F0EBE4] text-[#6B6763]",
    primary: "bg-[#F36353]/12 text-[#D94A3D]",
    sage: "bg-[#748C70]/15 text-[#4f6a4b]",
    warn: "bg-amber-100 text-amber-700",
  };
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${tones[tone]} ${className}`} {...rest}>
      {children}
    </span>
  );
}

// Back-compat alias (older imports used <Wordmark/>)
export function Wordmark({ className = "" }) {
  return <BpLogo className={className} />;
}
